module.exports = __webpack_public_path__ + "img/Shop_mini.6b531118.png";